import { useCallback, useEffect, useState } from "react";
import { getUserProjects } from "../services/projectService";
import { Project } from "../types/Project";

export function useUserProjects(userId: string | undefined) {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProjects = useCallback(async () => {
    if (!userId) {
      return;
    }

    try {
      const projects = await getUserProjects(userId);
      setProjects(projects);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return { projects, isLoading, error };
}
